import { useEffect, useState } from "react";

import { useProjectStore } from "@/stores/projectStore";
import { Checkbox } from "@/components/ui/checkbox";
import ProjectMemberRow from "@/components/myProjectsComp/ProjectMemberRow";
import AddProjectMemberModal from "@/components/modals/AddProjectMemberModal";
import { useGetAllProjectMembers } from "@/api/ProjetsApi";
import SmallLoader from "@/components/SmallLoader";

const ProjectMembers = () => {
  const {
    projects,
    selectedProject,
    selectedProjectMembers,
    setSelectedProject,
  } = useProjectStore();

  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const { getAllProjectMembers, loading } = useGetAllProjectMembers();
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  // Handle header checkbox toggle
  const toggleAllRows = (checked: boolean) => {
    if (checked) {
      if (selectedProjectMembers) {
        setSelectedRows(selectedProjectMembers.map((doc: any) => doc.id));
      }
    } else {
      setSelectedRows([]);
    }
  };

  // Handle individual row toggle
  const toggleRow = (id: string, checked: boolean) => {
    setSelectedRows((prev: string[]) =>
      checked ? [...prev, id] : prev.filter((rowId) => rowId !== id)
    );
  };

  // Update the screen height when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Update the screen height when the window is resized
  useEffect(() => {
    const updateSelectedProject = (id: string) => setSelectedProject(id);

    updateSelectedProject(selectedProject?.id || "string");
  }, [projects, selectedProject?.id, setSelectedProject]);

  useEffect(() => {
    getAllProjectMembers();
  }, []);

  return (
    <div className="flex-col space-y-2 h-fit w-full pt-2">
      <div className="grid grid-cols-[400px_2fr_2fr_.5fr] p-4 transition">
        <div className="flex items-center space-x-12">
          <Checkbox
            checked={
              selectedRows.length > 0 &&
              selectedRows.length === selectedProjectMembers?.length
            }
            onCheckedChange={(checked) => toggleAllRows(checked as boolean)}
          />
          <p className="text-sm text-gray-500">Nom de fichier</p>
        </div>
        <div className="text-sm text-gray-500">
          <p>Date ajoutée</p>
        </div>
        <div className="text-sm text-gray-500">
          <p>Dernière mise ȧ jour</p>
        </div>
        <div className="text-sm text-gray-500">
          <p>Taille du fichier</p>
        </div>
      </div>
      <div
        className={`flex-grow	 overflow-y-auto`}
        style={{ height: `${(screenHeight * (90 / 100)).toString()}` }}
      >
        {loading ? (
          <SmallLoader />
        ) : (
          selectedProjectMembers?.map((member, index) => (
            <ProjectMemberRow
              key={index}
              member={member}
              isChecked={selectedRows.includes(member.id)}
              onToggle={toggleRow}
            />
          ))
        )}
      </div>
      <AddProjectMemberModal />
    </div>
  );
};

export default ProjectMembers;
